import { type ReactNode } from "react";
import { cn } from "../../utils/global.utils";

type Props = {
  children: ReactNode;
  className?: string;
};

export default function Title({ children, className }: Props) {
  return (
    <h3
      className={cn(
        "text-theme-neutral-700 text-4xl lg:text-5xl font-semibold leading-[60px]",
        className
      )}
    >
      {children}
    </h3>
  );
}
